import { BuyerLanding } from "@/components/BuyerLanding";

export default function SalesManager() {
  return (
    <BuyerLanding
      testId="sales-manager-page"
      path="/for/sales-manager"
      seoTitle="Sales Department SOPs, Forms & Toolkit | Centennial"
      seoDescription="Onboard salespeople the same way every time, document performance and incidents cleanly, and run the floor on a system — not on memory."
      eyebrow="For Sales Managers"
      headline="Run a sales floor where every deal, every hire, every step is documented."
      subhead="Turnover is high and consistency is hard. Onboard new salespeople the same way every time, document performance and incidents cleanly, and keep the floor running on a system — not on memory."
      toolkitTitle="Your Sales toolkit"
      pains={[
        "New salespeople trained differently by whoever's free that day",
        "Performance and conduct issues with no documented trail",
        "Deal and delivery steps that vary from person to person",
        "A revolving door with no repeatable onboarding system",
      ]}
      packs={[
        { id: "pack_onboarding", name: "New-Hire Onboarding Pack", desc: "Give every new salesperson the same documented start with checklists, agreements, and first-week structure." },
        { id: "pack_incident", name: "Employee Incident Documentation Pack", desc: "Document write-ups, corrective action, and incidents consistently — so every decision is defensible." },
      ]}
      browseLink={{ label: "Browse all 28 Sales forms", to: "/forms?dept=Sales" }}
    />
  );
}
